module.exports = __webpack_public_path__ + "resources/img/logo_NCC.f33b9784b33fd3699431bc702c4ac4c6.svg";